import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppointmentAddComponent } from './appointment-add.component';
import { IonicModule } from '@ionic/angular';
import {
  MatDatepickerModule, MatSelectModule, MatFormFieldModule,
  MatNativeDateModule, MatInputModule, MAT_DATE_LOCALE
} from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '../../../shared/translate/translate.module';
import { FileAddModule } from '../../../shared/components/file-add/file-add.module';

@NgModule({
  declarations: [AppointmentAddComponent],
  imports: [
    CommonModule,
    IonicModule,
    MatDatepickerModule,
    MatSelectModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    FileAddModule
  ],
  exports: [AppointmentAddComponent],
  providers: [
    MatDatepickerModule,
    { provide: MAT_DATE_LOCALE, useValue: 'hu-HU' }
  ]
})
export class AppointmentAddModule { }
